var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafePayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.915,
    height: 23.11,
    viewBox: "0 0 17.915 23.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-1136.526 -30.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10448",
    "data-name": "Path 10448",
    d: "M30.777,13.672V24.634A5.014,5.014,0,0,1,28.9,28.549L22.42,33.73l-6.476-5.181a5.011,5.011,0,0,1-1.882-3.916V13.672L22.42,12Z",
    transform: "translate(1123.063 18.978)",
    fill: "none",
    stroke: "#717171",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10449",
    "data-name": "Path 10449",
    d: "M28.419,21,23.4,26.015l-3.343-3.343",
    transform: "translate(1122.078 17.5)",
    fill: "none",
    stroke: "#717171",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafePayment);
export default __webpack_public_path__ + "static/media/safe-payment.00323c44b7df1a1b4bc1cb04a056050a.svg";
export { ForwardRef as ReactComponent };